// extracted by mini-css-extract-plugin
export default {"container":"TitledCard_container__Irxh6","title":"TitledCard_title__33SsK"};